<template>
  <div
    :class="orientation"
    class="full"
  >
    <CourtHalf
      v-for="side in sides"
      :key="side"
      :expand="expand"
      :sidelines="sidelines"
      :side="side"
      class="half"
    />
  </div>
</template>

<script>
  import CourtHalf from './CourtHalf';

  export default {
    components: {
      CourtHalf,
    },
    props: {
      expand: {
        type: Boolean,
        default: false,
      },
      sidelines: {
        type: Boolean,
        default: false,
      },
      orientation: {
        type: String,
        default: 'horizontal',
        validator(orientation) {
          return ['horizontal', 'vertical'].includes(orientation);
        },
      },
    },
    computed: {
      sides() {
        return {
          vertical: ['top', 'bottom'],
          horizontal: ['left', 'right'],
        }[this.orientation];
      },
    },
  };
</script>

<style
  scoped
  lang="scss"
>
  .full {
    display: flex;
  }

  .half {
    .horizontal & {
      width: 50%;
    }

    .vertical & {
      height: 50%;
    }
  }

  .vertical {
    flex-direction: column;
  }
</style>
